module.exports = __webpack_public_path__ + "static/media/black@2x.0cacdb83.png";